import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import UsersContext from 'contexts/Users';

import UserList from './UserList';

const Container = styled.div`
	padding: 16px 40px;
`;

const Contact = props => {
	const {
		data: {
			data
		},
		building,
		unsavedChanges,
	} = props;

	let selectedUsers = [];

	if(unsavedChanges.contact) {
		// 1. Unsaved, but changed page data
		selectedUsers = unsavedChanges.contact;
	} else if(data.contact) {
		// 2. Previously saved page data
		selectedUsers = data.contact;
	} else if(building && Array.isArray(building.mappedContacts) && building.mappedContacts.length) {
		// 3. Default to first user from building contacts
		selectedUsers = building.mappedContacts.map(user => user.username);
	}

	return (
		<UsersContext.Consumer>
			{users => (
				<Container>
					<UserList users={users} selectedUsers={selectedUsers} handleChange={newContact => props.changesHandler({
						contact: newContact
					})} />
				</Container>
			)}
		</UsersContext.Consumer>
	);
};

Contact.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.oneOf(['fi', 'en']),
	unsavedChanges: PropTypes.object,
	data: PropTypes.object,
	changesHandler: PropTypes.func,
};

export default translate('translations')(Contact);
